"use strict";

require("./_half-image-with-description");